export default __webpack_public_path__ + "static/media/bg7.751ef276.jpg";